import * as React from 'react';
import JsonRenderComponent from "../../../../utils/JsonRenderComponent";
import { Element, scroller } from "react-scroll";

interface IProps {
    customer?: any;
    demographicProfile?: any;
    healthProfile?: any;
    heading?: string;
}

function scrollToTopOfResults() {
    scroller.scrollTo("customer-result", {
        delay: 0,
        duration: 800,
        offset: -250,
        smooth: "easeInOutQuart",
    });
}

class CustomerResult extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        return (
            <div>
                <br/>
                <h4>{this.props.heading}</h4>
                <p style={{
                    border: '3px solid lightgray',
                    padding: '5px',
                    whiteSpace: "pre-wrap",
                    wordBreak: "normal",
                    wordWrap: "break-word"
                }}>

                    {this.props.customer && scrollToTopOfResults()}

                    <Element name="customer-result" />
                    <JsonRenderComponent jsonObject={this.props.customer} printHtml={false} />
                </p>
            </div>
        );
    }
}

export default CustomerResult;